<div class="d-flex justify-content-end align-items-center">
  <button type="button" class="m-botton-dialog border-0" [matTooltip]="'Cerrar'" (click)="close()">
    <span aria-hidden="true">X</span>
  </button>
</div>
<div class="d-flex justify-content-center align-items-center">
   <p [innerHTML]="this.descripcion"></p>
</div>
